import axios from "axios";
import { config } from "@/config";

export type PublicSociety = {
  id: string;
  name: string;
  university: string | null;
};

/**
 * Fetch society names + university codes for the landing-page map (public).
 * Backend: GET /api/society/getPublicSocieties
 */
export const GetPublicSocietiesAPI = async (): Promise<PublicSociety[]> => {
  try {
    const resp = await axios.get(`${config.API_URL}/api/society/getPublicSocieties`, {
      headers: {
        apikey: config.API_KEY,
        appkey: "uninfo_web_landing",
        lang: "en",
      },
      timeout: 8000,
    });
    const data = resp.data?.resp;
    if (Array.isArray(data)) {
      return data.map((s: any) => ({
        id: s.id,
        name: s.name,
        university: s.university ?? null,
      }));
    }
    return [];
  } catch (err) {
    console.error(`GetPublicSocietiesAPI ${err}`);
    return [];
  }
};